// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"540":"82674d9267d106c7ad97","894":"b88db3b7fb0051c0175c","961":"041b1e93e453b6f30977"}[chunkId] + ".js";
};